import { render, staticRenderFns } from "./msgtypeCard.vue?vue&type=template&id=4dcd6bde&scoped=true&"
import script from "./msgtypeCard.vue?vue&type=script&lang=js&"
export * from "./msgtypeCard.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeCard.vue?vue&type=style&index=0&id=4dcd6bde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd6bde",
  null
  
)

export default component.exports